export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      "I had swim sets in one app, bike workouts in a spreadsheet and run plans in my notes. The six phases finally put everything in one place. For the first time I actually know what each week is for.",
    name: 'Ryan M.',
    location: 'Boulder, Colorado · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/3f03671e-87b2-41c5-9346-03aa31d63d16.jpg',
  },
  {
    quote:
      "Swimming was always the session I skipped. Seeing swim, bike and run laid out together made me stop treating them like three separate hobbies. My weeks finally feel balanced and consistent.",
    name: 'Jess K.',
    location: 'Sydney · Australia',
    flag: '🇦🇺',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/af095ff4-bd70-4313-bf02-29853a77c695.jpg',
  },
  {
    quote:
      "At 45 with a full-time job, I can't waste sessions. The 40-week calendar showed me where I am and what comes next. No more guessing whether I'm doing too much or too little.",
    name: 'Tom H.',
    location: 'Manchester · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/f10b1823-3db6-42e2-9134-f11a09189dd2.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      "The Fueling Vault was the piece I was missing. I used to run out of energy on every long ride. Now I plan my fueling before the session, not halfway through it.",
    name: 'Maria D.',
    location: 'Toronto · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/f398505f-cc14-4de9-a6f6-575807414f72.jpg',
  },
  {
    quote:
      "The Progress Tracker keeps me honest. Seeing my weekly consistency across all three sports tells me more than any single hard workout ever did.",
    name: 'Chris W.',
    location: 'Austin, Texas · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/248b0d04-34fe-4097-a4a8-77691f359c5a.jpg',
  },
  {
    quote:
      "Race week used to be chaos. The Command Center turned it into a plan — bags packed, transitions sorted, race morning mapped out. I lined up calm for the first time.",
    name: 'Emily S.',
    location: 'Auckland · New Zealand',
    flag: '🇳🇿',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/88945897-f0a3-47db-a702-a15129dedc23.jpg',
  },
];
